import RouterViewBody from '~/views/RouterViewBody.vue'
import { userCheckAccess } from '../../configs/methods'

export default [
  {
    path: 'finance',
    name: 'finance',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    props: { type: 'finance' },
    redirect: () => {
      return {
        name: userCheckAccess({
          abilities: 'view_invoices',
        })
          ? 'financeInvoice'
          : 'financeSalaryList',
      }
    },
    meta: {
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.pages.buttons.finance,
    },
    children: [
      {
        path: 'salary',
        redirect: {
          name: 'financeSalary',
        },
        component: RouterViewBody,
        meta: {
          access: { abilities: ['view_salary'] },
        },
        children: [
          {
            path: '',
            name: 'financeSalary',
            component: () => import('~/views/finance/salary/salary.vue'),
            redirect: { name: 'financeSalaryList' },
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.finance.pages.salary,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
            children: [
              {
                path: 'slice',
                name: 'financeSalaryMain',
                redirect: { name: 'financeSalarySlice' },
                component: () => import('~/views/finance/salary/salarySlice.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.finance.pages['salary-slice'],
                  paginations: {
                    page: 1,
                    limit: 10,
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'financeSalarySlice',
                    component: RouterViewBody,
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                    },
                  },
                  {
                    path: ':period_id',
                    component: () => import('~/views/finance/salary/salarySliceShow.vue'),
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                      breadCrumbGetter: 'employeeSalaryPeriod/employeeSalaryPeriod',
                      breadCrumb: (data) =>
                        data.period.start && data.period.end
                          ? data.period.start.split('/').join('.') + ' - ' + data.period.end.split('/').join('.')
                          : '',
                    },
                    children: [
                      {
                        path: '',
                        name: 'financeSalarySliceShow',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: 'balance',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                        children: [
                          {
                            path: '',
                            component: () => import('~/views/finance/salary/salarySliceShow.vue'),
                            name: 'financeSalarySliceShowBalance',
                            meta: {
                              responsive: true,
                            },
                          },
                        ],
                      },
                      {
                        path: 'manual',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                        children: [
                          {
                            path: '',
                            component: () => import('~/views/finance/salary/salarySliceShow.vue'),
                            name: 'financeSalarySliceShowManual',
                            meta: {
                              responsive: true,
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: 'manual',
                component: () => import('~/views/finance/salary/salaryManual.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.finance.pages['salary-manual'],
                  paginations: {
                    page: 1,
                    limit: 10,
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'financeSalaryManual',
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                    },
                  },
                ],
              },
              {
                path: 'list',
                component: () => import('~/views/finance/salary/salaryList.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.finance.pages['list'],
                  paginations: {
                    page: 1,
                    limit: 10,
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'financeSalaryList',
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                    },
                  },
                  {
                    path: ':id',
                    component: () => import('~/views/finance/salary/salaryListShow.vue'),
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.finance['salary-table']['period'],
                    },
                    children: [
                      {
                        path: '',
                        name: 'financeSalaryListShow',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                    ]
                  }
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'invoice',
        redirect: { name: 'financeInvoiceWidget' },
        component: RouterViewBody,
        meta: {
          access: { abilities: ['view_invoices'] },
        },
        children: [
          {
            path: '',
            name: 'financeInvoice',
            redirect: { name: 'financeInvoiceWidget' },
            component: () => import('~/views/finance/invoice/invoice.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.finance.pages['invoice'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
            children: [
              {
                path: 'widget',
                component: () => import('~/views/finance/invoice/invoiceWidget.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.finance.pages['list'],
                  paginations: {
                    page: 1,
                    limit: 10,
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'financeInvoiceWidget',
                    component: RouterViewBody,
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                    },
                  },
                  {
                    path: ':invoice_id',
                    component: () => import('~/views/finance/invoice/invoiceShow.vue'),
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.finance['invoice-table']['invoice'],
                    },
                    children: [
                      {
                        path: '',
                        name: 'financeInvoiceWidgetBillShow',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: 'edit',
                        name: 'financeInvoiceWidgetBillShowEdit',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: 'pdf',
                        name: 'financeInvoiceWidgetBillShowPdf',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'full',
                component: () => import('~/views/finance/invoice/invoiceFull.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.finance.pages['full_information'],
                  paginations: {
                    page: 1,
                    limit: 10,
                  },
                },
                children: [
                  {
                    path: '',
                    name: 'financeInvoiceFull',
                    component: RouterViewBody,
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                    },
                  },
                  {
                    path: ':invoice_id',
                    component: () => import('~/views/finance/invoice/invoiceShow.vue'),
                    meta: {
                      responsive: true,
                      paginations: {
                        page: 1,
                        limit: 10,
                      },
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.finance['invoice-table']['invoice'],
                    },
                    children: [
                      {
                        path: '',
                        name: 'financeInvoiceFullBillShow',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: 'edit',
                        name: 'financeInvoiceFullBillShowEdit',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                      {
                        path: 'pdf',
                        name: 'financeInvoiceFullBillShowPdf',
                        component: RouterViewBody,
                        meta: {
                          responsive: true,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]
